import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { RECALLS_DEFAULT_FILTER, type RecallsFilter } from '@/state';
import type { FC } from 'react';
import { RecallsTable } from './RecallsTable';

const REJECTED_FILTER: RecallsFilter = { ...RECALLS_DEFAULT_FILTER, status: 'rejected' };

/** Recalls an admin set aside: kept for the record, matching nothing until reopened. */
export const RejectedRecallsTab: FC = () => (
    <Card>
        <CardHeader>
            <CardTitle>Rejected</CardTitle>
            <CardDescription>
                Kept for the record; they match nothing. Tap a row to review or reopen the recall.
            </CardDescription>
        </CardHeader>
        <CardContent>
            <RecallsTable filter={REJECTED_FILTER} emptyText="No rejected recalls." />
        </CardContent>
    </Card>
);
